import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';
import { BannerStack } from './BannerStack';
import { useSubscriptionBanner } from '../../hooks/useSubscriptionBanner';
import { useTrialBanner } from '../../hooks/useTrialBanner';
import { useSetupBanner } from '../../hooks/useSetupBanner';
import { useInstallBanner } from '../../hooks/useInstallBanner';

/**
 * AppShell — wraps every page with the shared chrome:
 * top bar + banner stack + scrollable content area.
 */
export function AppShell() {
  // Register app-wide banners (subscription, trial, setup, etc.)
  useSubscriptionBanner();
  useTrialBanner();
  useSetupBanner();
  useInstallBanner();

  return (
    <div className="page">
      <TopBar />

      <main
        className="flex-1 overflow-y-auto"
        style={{
          paddingTop: 'var(--header-height)',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }}
      >
        <BannerStack />
        <Outlet />
      </main>
    </div>
  );
}
